<style lang="scss" scoped>
  .question {
    padding: 40px 20px;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    border-top-left-radius: var(--global-radius);
    border-top-right-radius: var(--global-radius);
    .btn {
      padding: 10px 40px;
      margin: 10px 6px;
    }
  }
  .btn-plain {
    color: white;
    background: rgba(255,255,255,.2);
  }
  .mv {
    margin-bottom: 0px;
  }
</style>

<template>
  <div id="reviewprompt">
    <div class="question orange">
      <div v-html="message" />
      <div class="mv">
        <button class="btn btn-plain" @click="$emit('complete', true)">{{ $t('UpgradePrompt.yes-please') }}</button>
        <button class="btn btn-plain" @click="$emit('complete', false)">{{ $t('EditActions.maybe-later') }}...</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    let messageList = [
      `<p>${this.$t('UpgradePrompt.thank-you-for-using-the')} <strong>${this.$t('UpgradePrompt.free-version')}</strong> ${this.$t('UpgradePrompt.of-intimately-us-ready-for-an-upgrade')}</p>`,
      `<p>${this.$t('UpgradePrompt.you-re-missing-out-the')} <strong>${this.$t('UpgradePrompt.premium-version')}</strong> ${this.$t('UpgradePrompt.helps-you-connect-more-intimately-without-limitations-ready-to-upgrade')}</p>`,
      `<p>${this.$t('UpgradePrompt.would-you-like-to-remove-ads-unlock-all-bedroom-games-see-more-flirty-invites-more-sexploration-and-fun')}</p>`,
      `<p>${this.$t('UpgradePrompt.pssst-the-premium-version-of-intimately-us-has-a-lot-more-features-and-is-affordable-too-interested')}</p>`,
    ]
    return {
      messageList,
      message: '',
    }
  },
  mounted () {
    this.message = this.messageList[Math.floor(Math.random() * this.messageList.length)];
  }
}
</script>